import { NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, output, viewChild } from '@angular/core';
import { DxTreeViewComponent, DxTreeViewModule } from 'devextreme-angular';
import { DataStructure, ItemClickEvent, ItemSelectionChangedEvent } from 'devextreme/ui/tree_view';

@Component({
  selector: 'app-tree-view',
  standalone: true,
  imports: [DxTreeViewModule, NgTemplateOutlet],
  templateUrl: './tree-view.component.html',
  styleUrl: './tree-view.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TreeViewComponent {
  dxTreeView = viewChild.required(DxTreeViewComponent);

  dataSource = input<unknown[]>();
  items = input<unknown[]>();
  displayExpr = input<string | ((item: unknown) => string)>('text');
  itemsExpr = input<string | (() => string)>('items');
  keyExpr = input<string | (() => string)>('id');
  parentIdExpr = input<string | (() => string)>('parentId');
  dataStructure = input<DataStructure>('tree');
  virtualModeEnabled = input<boolean>(false);
  itemTemplate = input<unknown>(null);
  height = input<string | number>(undefined);
  itemClick = output<ItemClickEvent>();
  itemSelectionChanged = output<ItemSelectionChangedEvent>();

  onItemClick(e: ItemClickEvent) {
    this.itemClick.emit(e);
  }

  onItemSelectionChanged(e: ItemSelectionChangedEvent) {
    this.itemSelectionChanged.emit(e);
  }
}
